module.exports = __webpack_public_path__ + "img/server.89d5e80e.png";